import { PaymentSession } from "@/models/payment/interfaces/payment";

export const getPaymentSessionToken = (state: PaymentSession): string => {
  return state.paymentSessionToken;
};

export const getPaymentSessionKey = (state: PaymentSession): string => {
  return state.paymentSessionKey;
};

export const getFPPaymentKey = (state): string => {
  return state.FPPaymentKey;
};
